import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"hamburger\"><path d=\"M0 1a1 1 0 011-1h11a1 1 0 010 2H1a1 1 0 01-1-1zm0 7a1 1 0 011-1h14a1 1 0 010 2H1a1 1 0 01-1-1zm0 7a1 1 0 011-1h7a1 1 0 010 2H1a1 1 0 01-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol